module.exports = __webpack_public_path__ + "img/68.9c4f58a.jpg";